import { Injectable } from '@angular/core';
import { ChatAppTelemetryService } from './chat-app-telemetry.service';

/**
 * Closes the loop on a notification activation — SPEC-2026-09-internal-chat-pwa (T-39 ·
 * RNF-07). The worker (or the cold-start address) says a notification was activated for
 * a conversation; the conversation route says whether that conversation actually opened.
 * One event per activation.
 */
@Injectable({ providedIn: 'root' })
export class ChatAppActivationService {

  private expectedChannelId: string | null = null;

  constructor(private readonly telemetry: ChatAppTelemetryService) { }

  /** A notification for `channelId` was activated; the route will resolve it. */
  expect(channelId: string | null): void {
    if (!channelId) {
      // A notification without a conversation opens the list — that is its intent.
      this.telemetry.reportPushActivation(true);
      return;
    }
    this.expectedChannelId = channelId;
  }

  /** The conversation route settled: opened, or not available. */
  resolve(channelId: string, opened: boolean): void {
    if (!this.expectedChannelId || this.expectedChannelId !== channelId) return;
    this.expectedChannelId = null;
    this.telemetry.reportPushActivation(opened);
  }
}
